export default String.raw`
.widget {
    padding: 12px 39px 12px 12px;
    width: 100%;
    top: 0;
    left: 50%;
    right: 50%;
    border-radius: 0 !important;
    height: 110px;

    $parent: &;

    &__close {
        visibility: visible;
    }

    &__outlier {
        display: none;
    }

    &__content {
        width: 100%;

        p {
            -webkit-line-clamp: 2;
            @include subtitle-2-medium;
        }
    }

    &.rightBottom,
    &.rightTop,
    &.leftTop,
    &.leftBottom {
        left: 0;
        right: auto;
        transition: none;

        &:hover {
            left: 0;
            right: auto;
        }
    }
}
`